export const diagnosticOperations = ["app", "capture", "photo_upload", "research", "manual_listing", "stock_adjustment", "stock_review", "catalogue_update", "sale", "support"] as const;
export const diagnosticRoutes = ["dashboard", "inventory", "listings", "orders", "channels", "analytics", "settings", "signin", "other"] as const;
export interface ClientDiagnostic {
  id: string;
  operation: typeof diagnosticOperations[number];
  outcome: "success" | "failure" | "opened";
  route: typeof diagnosticRoutes[number];
  durationMs: number;
  release: string;
  failure?: "render" | "unhandled" | "operation";
}

/** An allowlist, shared with the server. No exception text, URL, item content or customer data. */
export function validateClientDiagnostic(value: unknown): ClientDiagnostic {
  if (!value || typeof value !== "object" || Array.isArray(value)) throw new Error("Invalid diagnostic.");
  const input = value as ClientDiagnostic;
  if (Object.keys(input).some((key) => !["id", "operation", "outcome", "route", "durationMs", "release", "failure"].includes(key)) ||
    typeof input.id !== "string" || !/^[a-f0-9-]{36}$/.test(input.id) ||
    !diagnosticOperations.includes(input.operation) || !["success", "failure", "opened"].includes(input.outcome) ||
    !diagnosticRoutes.includes(input.route) || !Number.isInteger(input.durationMs) || input.durationMs < 0 || input.durationMs > 86400000 ||
    typeof input.release !== "string" || !/^[a-zA-Z0-9._-]{1,64}$/.test(input.release) ||
    (input.failure !== undefined && !["render", "unhandled", "operation"].includes(input.failure))) throw new Error("Invalid diagnostic.");
  return { id: input.id, operation: input.operation, outcome: input.outcome, route: input.route, durationMs: input.durationMs, release: input.release, ...(input.failure ? { failure: input.failure } : {}) };
}
